var _style, _g, _rect, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaLogoColorBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.06,
    y: 1100.39,
    className: "st0",
    width: 20.55,
    height: 140.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.14,1240.28v-74.31l19.87-19.79v94.1L278.14,1240.28L278.14,1240.28z M169.93,1153.71v86.94h-18.75v-140.26 l73.35,72.34l73.35-72.34v30.66l-73.34,73.24L169.93,1153.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.21,1240.28v-94.1l20.55,24.07v70.03H398.21z M398.22,1131.05v-30.66l98.77,116.86v-116.86h20.95v140.26h-25.67 L398.22,1131.05z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.47,
    y: 1100.39,
    width: 20.55,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.82,
    y: 1100.39,
    width: 63.09,
    height: 21.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.82,
    y: 1161.24,
    width: 63.09,
    height: 20.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.82,
    y: 1219.48,
    width: 63.09,
    height: 21.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1186.06,1130.01c7.71,0,14.96,1.46,21.75,4.37c6.79,2.91,12.7,6.88,17.72,11.9c5.02,5.02,8.97,10.92,11.86,17.7 c2.89,6.78,4.33,14.04,4.33,21.77c0,7.63-1.44,14.82-4.33,21.54c-2.89,6.73-6.84,12.61-11.86,17.63s-10.93,8.99-17.72,11.9 c-6.8,2.91-14.04,4.37-21.75,4.37c-7.71,0-14.93-1.46-21.68-4.37c-6.74-2.91-12.62-6.88-17.64-11.9s-8.98-10.9-11.86-17.63 c-2.89-6.73-4.34-13.91-4.34-21.54c0-7.73,1.45-14.99,4.34-21.77s6.85-12.68,11.86-17.7c5.02-5.02,10.9-8.99,17.64-11.9 C1171.14,1131.45,1178.36,1130.01,1186.06,1130.01z M1186.06,1225.68c5.27,0,10.27-1.05,14.98-3.15 c4.71-2.1,8.82-4.95,12.32-8.56c3.5-3.6,6.26-7.83,8.29-12.68c2.03-4.85,3.04-10.03,3.04-15.53s-1.01-10.71-3.04-15.61 s-4.79-9.18-8.29-12.83c-3.5-3.65-7.61-6.53-12.32-8.63c-4.71-2.1-9.71-3.15-14.98-3.15c-5.27,0-10.24,1.05-14.91,3.15 c-4.66,2.1-8.75,4.98-12.24,8.63c-3.5,3.65-6.26,7.93-8.29,12.83c-2.03,4.9-3.04,10.11-3.04,15.61s1.01,10.68,3.04,15.53 c2.03,4.85,4.79,9.08,8.29,12.68c3.5,3.6,7.58,6.45,12.24,8.56C1175.82,1224.62,1180.79,1225.68,1186.06,1225.68z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281.64,
    y: 1100.39,
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.97,
    y: 1100.39,
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.67,
    y: 1100.39,
    width: 36.84,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1311.98,
    y: 1100.39,
    width: 36.84,
    height: 19.34
  })), /*#__PURE__*/React.createElement("path", {
    d: "M711.46,1100.39v140.07h-20.55v-140.07L711.46,1100.39L711.46,1100.39z M795.42,1240.65h-26.54l-46.9-60.78h21.98 c4.23,0,32.5-1.05,32.5-29.35c0-25.68-23.21-30.8-32.5-30.8h-21.98v-19.34h19.49c11.52,0,53.19,4.77,53.19,49.95 c0,33.32-29.01,46.53-34.18,46.53L795.42,1240.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.34,1100.39l61.44,140.26h-22.87l-38.55-85.23l-38.55,85.23h-22.87L994.34,1100.39z M1004.39,1219.3h-19.87v21.35 h19.87V1219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.21,1240.65l-61.44-140.26h22.87l38.55,85.23l38.55-85.23h22.87L877.21,1240.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "249.03,1030.26 315.56,1030.26 483.85,427.13 517.12,546.35 382.09,1030.26 448.64,1030.26 550.4,665.57  550.4,665.57 652.16,1030.26 718.68,1030.26 503.43,258.81 464.29,258.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1035.71,258.81 996.58,258.81 816.54,904.03 749.99,665.57 863.51,258.81 796.96,258.81 716.73,546.35  636.49,258.81 569.96,258.81 785.22,1030.26 847.84,1030.26 916.34,784.79 984.84,1030.26 1051.36,1030.26 949.6,665.57  1016.15,427.13 1184.43,1030.26 1250.97,1030.26  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1241.68,266.44h-21.14v-7.63h51.45v7.63h-21.24v61.87h-9.08v-61.87H1241.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.3,297.79c-0.52-9.69-1.13-21.35-1.03-30.01h-0.31c-2.37,8.15-5.26,16.81-8.77,26.4l-12.27,33.72h-6.81l-11.24-33.1 c-3.3-9.8-6.08-18.77-8.04-27.02h-0.21c-0.21,8.66-0.72,20.32-1.34,30.73l-1.86,29.8h-8.56l4.85-69.5h11.45l11.86,33.62 c2.89,8.56,5.26,16.19,7.01,23.41h0.31c1.75-7.01,4.23-14.64,7.32-23.41l12.37-33.62h11.45l4.33,69.5h-8.77L1338.3,297.79z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1782,
    width: 1500,
    height: 1500
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2121.07,
    y: 1100.38,
    className: "st1",
    width: 20.55,
    height: 140.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2060.14,1240.27v-74.31l19.87-19.79v94.1L2060.14,1240.27L2060.14,1240.27z M1951.93,1153.71v86.94h-18.75 v-140.26l73.35,72.34l73.35-72.34v30.66l-73.34,73.24L1951.93,1153.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2180.22,1240.27v-94.1l20.55,24.07v70.03H2180.22z M2180.22,1131.04v-30.66l98.77,116.86v-116.86h20.95 v140.26h-25.67L2180.22,1131.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2337.47,
    y: 1100.38,
    className: "st2",
    width: 20.55,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2368.83,
    y: 1100.38,
    className: "st2",
    width: 63.09,
    height: 21.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2368.83,
    y: 1161.24,
    className: "st2",
    width: 63.09,
    height: 20.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2368.83,
    y: 1219.48,
    className: "st2",
    width: 63.09,
    height: 21.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2968.07,1130c7.71,0,14.96,1.46,21.75,4.37s12.7,6.88,17.72,11.9s8.97,10.92,11.86,17.7 c2.89,6.78,4.33,14.04,4.33,21.77c0,7.63-1.44,14.82-4.33,21.54c-2.89,6.73-6.84,12.61-11.86,17.63s-10.93,8.99-17.72,11.9 c-6.8,2.91-14.04,4.37-21.75,4.37s-14.93-1.46-21.68-4.37c-6.74-2.91-12.62-6.88-17.64-11.9s-8.98-10.9-11.86-17.63 c-2.89-6.73-4.34-13.91-4.34-21.54c0-7.73,1.45-14.99,4.34-21.77c2.89-6.78,6.85-12.68,11.86-17.7 c5.02-5.02,10.9-8.99,17.64-11.9C2953.14,1131.45,2960.36,1130,2968.07,1130z M2968.07,1225.67c5.27,0,10.27-1.05,14.98-3.15 s8.82-4.95,12.32-8.56c3.5-3.6,6.26-7.83,8.29-12.68c2.03-4.85,3.04-10.03,3.04-15.53s-1.01-10.71-3.04-15.61 s-4.79-9.18-8.29-12.83c-3.5-3.65-7.61-6.53-12.32-8.63s-9.71-3.15-14.98-3.15s-10.24,1.05-14.91,3.15 c-4.66,2.1-8.74,4.98-12.24,8.63s-6.26,7.93-8.29,12.83c-2.03,4.9-3.04,10.11-3.04,15.61s1.01,10.68,3.04,15.53 s4.79,9.08,8.29,12.68c3.5,3.6,7.58,6.45,12.24,8.56C2957.83,1224.62,2962.79,1225.67,2968.07,1225.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3063.63,
    y: 1100.38,
    className: "st2",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2860.98,
    y: 1100.38,
    className: "st2",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3017.68,
    y: 1100.38,
    className: "st2",
    width: 36.84,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3093.99,
    y: 1100.38,
    className: "st2",
    width: 36.84,
    height: 19.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2493.46,1100.38v140.07h-20.55v-140.07L2493.46,1100.38L2493.46,1100.38z M2577.42,1240.64h-26.54 l-46.9-60.78h21.98c4.23,0,32.5-1.05,32.5-29.35c0-25.68-23.21-30.8-32.5-30.8h-21.98v-19.34h19.49 c11.52,0,53.19,4.77,53.19,49.95c0,33.32-29.01,46.53-34.18,46.53L2577.42,1240.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2776.34,1100.38l61.44,140.26h-22.87l-38.55-85.23l-38.55,85.23h-22.87L2776.34,1100.38z M2786.39,1219.29 h-19.87v21.35h19.87V1219.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2659.22,1240.64l-61.44-140.26h22.87l38.55,85.23l38.55-85.23h22.87L2659.22,1240.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "2031.02,1030.25 2097.56,1030.25 2265.86,427.13 2299.12,546.35 2164.1,1030.25 2230.63,1030.25  2332.39,665.57 2332.39,665.57 2434.15,1030.25 2500.69,1030.25 2285.43,258.81 2246.29,258.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2817.71,258.81 2778.57,258.81 2598.54,904.02 2532,665.57 2645.5,258.81 2578.97,258.81  2498.73,546.35 2418.5,258.81 2351.96,258.81 2567.23,1030.25 2629.85,1030.25 2698.34,784.79 2766.83,1030.25 2833.37,1030.25  2731.61,665.57 2798.14,427.13 2966.44,1030.25 3032.98,1030.25  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3023.68,266.44h-21.14v-7.63H3054v7.63h-21.24v61.87h-9.08V266.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3120.3,297.79c-0.52-9.69-1.13-21.35-1.03-30.01h-0.31c-2.37,8.15-5.26,16.81-8.77,26.4l-12.27,33.72h-6.81 l-11.24-33.1c-3.3-9.8-6.08-18.77-8.04-27.02h-0.21c-0.21,8.66-0.72,20.32-1.34,30.73l-1.86,29.8h-8.56l4.85-69.5h11.45 l11.86,33.62c2.89,8.56,5.26,16.19,7.01,23.41h0.31c1.75-7.01,4.23-14.64,7.32-23.41l12.37-33.62h11.45l4.33,69.5h-8.77 L3120.3,297.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaLogoColorBlock);
export default __webpack_public_path__ + "static/media/Minerva_LogoColorBlock.dd621ad4158289a83e6fb86060ddfd65.svg";
export { ForwardRef as ReactComponent };